import React, { CSSProperties, FC, ReactNode } from "react";

import { Container, DescriptionBlock, TextInfoContainer } from "../../styled";
import { AliasBlock, Image } from "../styled";

import { ResourceMeta } from "../../../../hooks/useResourceMeta";

interface ReadOnlyMetaProps extends ResourceMeta {
  children: ReactNode;
  extra?: ReactNode;
  loading?: boolean;
  noMeta?: boolean;
  imageStyle?: CSSProperties;
  showCopyrightAndDescription?: boolean;
  showDescription?: boolean;
  showSystemName?: boolean;
}

export const ReadOnlyMeta: FC<ReadOnlyMetaProps> = ({
  preview,
  alias,
  description,
  children,
  loading,
  noMeta,
  imageStyle,
  extra,
}) => (
  <Container>
    <Image loading={loading} loadable src={(preview && preview.src) || null} style={imageStyle} />
    <TextInfoContainer>
      {!noMeta && (
        <div>
          <AliasBlock>{alias}</AliasBlock>
          <DescriptionBlock>{description}</DescriptionBlock>
          {extra}
        </div>
      )}
      {children}
    </TextInfoContainer>
  </Container>
);
